import { listGroups } from "./listGroups";
export function initSearch(deacons) {
    const searchInput = document.querySelector("#deacon-search");
    if (searchInput.hasAttribute("disabled")) {
        searchInput.removeAttribute("disabled");
        searchInput.focus();
        searchInput.addEventListener("keyup", (e) => {
            const target = e.target;
            const val = target.value.toLowerCase().trim();
            const results = deacons.filter((deacon) => {
                var _a;
                if ((deacon["first-name"] + " " + deacon["last-name"])
                    .toLowerCase()
                    .indexOf(val) > -1 ||
                    deacon.groups
                        .map((group) => group.toLowerCase())
                        .indexOf(val) > -1 ||
                    ((_a = deacon["serves-in"]) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(val)) > -1 ||
                    deacon.email.toLowerCase().indexOf(val) > -1 ||
                    (val.replace(/\D/g, "").length &&
                        deacon.cell.replace(/\D/g, "") ===
                            val.replace(/\D/g, ""))) {
                    return true;
                }
                return false;
            });
            listGroups(results);
        });
    }
}
